import MenuNames from "../../../constants/Menu/MenuNames.json";
import PlatformFeeDetails from "../../../views/PlatformFeeDetails";

const PlatformFeeDetailsRoutes = [
    {
        menuName: MenuNames.RIDER_PAYOUT_HISTORY,
        path: "/platform-fee-details",
        component: PlatformFeeDetails,
        exact: true,
    },
];

export default PlatformFeeDetailsRoutes;
